<template>
    <div class="wrapper">

        <header-main></header-main>

        <div id="enter-promo" class="popup popup--promocode">
            <div class="popup__wrapper">
                <div class="popup__content">
                    <div class="popup__wrap">
                        <button class="popup__btn popup__close" @click="closePopup">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.0002 36.6667C29.1668 36.6667 36.6668 29.1667 36.6668 20C36.6668 10.8334 29.1668 3.33337 20.0002 3.33337C10.8335 3.33337 3.3335 10.8334 3.3335 20C3.3335 29.1667 10.8335 36.6667 20.0002 36.6667Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                ></path>
                                <path d="M15.2832 24.7165L24.7165 15.2832" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M24.7165 24.7165L15.2832 15.2832" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </button>
                        <div class="popup__main">
                            <div class="popup__title title">
                                <svg width="168" height="43" viewBox="0 0 168 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M153.094 17.3027L138.864 3.14195L124.625 17.3027L110.395 3.14195L96.1652 17.3027L83.6144 4.81251L71.0549 17.3027L56.8249 3.14195L42.5862 17.3027L28.3562 3.14195L14.1262 17.3027L0 3.24582L1.57534 1.67048L14.1262 14.1607L28.3562 -7.717e-05L42.5862 14.1607L56.8249 -7.717e-05L71.0549 14.1607L83.6144 1.66182L96.1652 14.1607L110.395 -7.717e-05L124.625 14.1607L138.864 -7.717e-05L153.094 14.1607L165.653 1.67048L167.22 3.24582L153.094 17.3027Z"
                                        fill="#E9417D"
                                    ></path>
                                    <path
                                        d="M153.096 42.6211L138.866 28.4603L124.627 42.6211L110.397 28.4603L96.1668 42.6211L84.8798 31.3859L84.8711 28.2353L96.1668 39.4791L110.397 25.3183L124.627 39.4791L138.866 25.3183L153.096 39.4791L165.655 26.9888L167.222 28.5728L153.096 42.6211Z"
                                        fill="#E9417D"
                                    ></path>
                                </svg>
                                {{ $store.state.translation.promo.main.activate_promocode }}
                                <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M54.7825 5.02247C53.6325 6.17247 51.7725 6.17247 50.6225 5.02247C49.4725 3.87247 49.4725 2.0125 50.6225 0.8625C51.7725 -0.2875 53.6325 -0.2875 54.7825 0.8625C55.9325 2.0125 55.9325 3.87247 54.7825 5.02247ZM67.2225 13.3025C66.0725 12.1525 64.2125 12.1525 63.0625 13.3025C61.9125 14.4525 61.9125 16.3125 63.0625 17.4625C64.2125 18.6125 66.0725 18.6125 67.2225 17.4625C68.3725 16.3125 68.3725 14.4525 67.2225 13.3025ZM79.6625 25.7425C78.5125 24.5925 76.6525 24.5925 75.5025 25.7425C74.3525 26.8925 74.3525 28.7525 75.5025 29.9025C76.6525 31.0525 78.5125 31.0525 79.6625 29.9025C80.8125 28.7525 80.8125 26.8925 79.6625 25.7425ZM92.1025 38.1825C90.9525 37.0325 89.0925 37.0325 87.9425 38.1825C86.7925 39.3325 86.7925 41.1925 87.9425 42.3425C89.0925 43.4925 90.9525 43.4925 92.1025 42.3425C93.2525 41.1925 93.2525 39.3325 92.1025 38.1825ZM104.542 50.6225C103.392 49.4725 101.533 49.4725 100.383 50.6225C99.2325 51.7725 99.2325 53.6325 100.383 54.7825C101.533 55.9325 103.392 55.9325 104.542 54.7825C105.692 53.6325 105.692 51.7725 104.542 50.6225ZM42.3425 13.3025C41.1925 12.1525 39.3325 12.1525 38.1825 13.3025C37.0325 14.4525 37.0325 16.3125 38.1825 17.4625C39.3325 18.6125 41.1925 18.6125 42.3425 17.4625C43.4925 16.3125 43.4925 14.4525 42.3425 13.3025ZM54.7825 25.7425C53.6325 24.5925 51.7725 24.5925 50.6225 25.7425C49.4725 26.8925 49.4725 28.7525 50.6225 29.9025C51.7725 31.0525 53.6325 31.0525 54.7825 29.9025C55.9325 28.7525 55.9325 26.8925 54.7825 25.7425ZM67.2225 38.1825C66.0725 37.0325 64.2125 37.0325 63.0625 38.1825C61.9125 39.3325 61.9125 41.1925 63.0625 42.3425C64.2125 43.4925 66.0725 43.4925 67.2225 42.3425C68.3725 41.1925 68.3725 39.3325 67.2225 38.1825ZM79.6625 50.6225C78.5125 49.4725 76.6525 49.4725 75.5025 50.6225C74.3525 51.7725 74.3525 53.6325 75.5025 54.7825C76.6525 55.9325 78.5125 55.9325 79.6625 54.7825C80.8125 53.6325 80.8125 51.7725 79.6625 50.6225ZM92.1025 63.0625C90.9525 61.9125 89.0925 61.9125 87.9425 63.0625C86.7925 64.2125 86.7925 66.0725 87.9425 67.2225C89.0925 68.3725 90.9525 68.3725 92.1025 67.2225C93.2525 66.0725 93.2525 64.2125 92.1025 63.0625ZM29.9025 25.7425C28.7525 24.5925 26.8925 24.5925 25.7425 25.7425C24.5925 26.8925 24.5925 28.7525 25.7425 29.9025C26.8925 31.0525 28.7525 31.0525 29.9025 29.9025C31.0525 28.7525 31.0525 26.8925 29.9025 25.7425ZM42.3425 38.1825C41.1925 37.0325 39.3325 37.0325 38.1825 38.1825C37.0325 39.3325 37.0325 41.1925 38.1825 42.3425C39.3325 43.4925 41.1925 43.4925 42.3425 42.3425C43.4925 41.1925 43.4925 39.3325 42.3425 38.1825ZM54.7825 50.6225C53.6325 49.4725 51.7725 49.4725 50.6225 50.6225C49.4725 51.7725 49.4725 53.6325 50.6225 54.7825C51.7725 55.9325 53.6325 55.9325 54.7825 54.7825C55.9325 53.6325 55.9325 51.7725 54.7825 50.6225ZM67.2225 63.0625C66.0725 61.9125 64.2125 61.9125 63.0625 63.0625C61.9125 64.2125 61.9125 66.0725 63.0625 67.2225C64.2125 68.3725 66.0725 68.3725 67.2225 67.2225C68.3725 66.0725 68.3725 64.2125 67.2225 63.0625ZM79.6625 75.5025C78.5125 74.3525 76.6525 74.3525 75.5025 75.5025C74.3525 76.6525 74.3525 78.5125 75.5025 79.6625C76.6525 80.8125 78.5125 80.8125 79.6625 79.6625C80.8125 78.5125 80.8125 76.6425 79.6625 75.5025ZM17.4625 38.1825C16.3125 37.0325 14.4525 37.0325 13.3025 38.1825C12.1525 39.3325 12.1525 41.1925 13.3025 42.3425C14.4525 43.4925 16.3125 43.4925 17.4625 42.3425C18.6125 41.1925 18.6125 39.3325 17.4625 38.1825ZM29.9025 50.6225C28.7525 49.4725 26.8925 49.4725 25.7425 50.6225C24.5925 51.7725 24.5925 53.6325 25.7425 54.7825C26.8925 55.9325 28.7525 55.9325 29.9025 54.7825C31.0525 53.6325 31.0525 51.7725 29.9025 50.6225ZM42.3425 63.0625C41.1925 61.9125 39.3325 61.9125 38.1825 63.0625C37.0325 64.2125 37.0325 66.0725 38.1825 67.2225C39.3325 68.3725 41.1925 68.3725 42.3425 67.2225C43.4925 66.0725 43.4925 64.2125 42.3425 63.0625ZM54.7825 75.5025C53.6325 74.3525 51.7725 74.3525 50.6225 75.5025C49.4725 76.6525 49.4725 78.5125 50.6225 79.6625C51.7725 80.8125 53.6325 80.8125 54.7825 79.6625C55.9325 78.5125 55.9325 76.6425 54.7825 75.5025ZM67.2225 87.9425C66.0725 86.7925 64.2125 86.7925 63.0625 87.9425C61.9125 89.0925 61.9125 90.9525 63.0625 92.1025C64.2125 93.2525 66.0725 93.2525 67.2225 92.1025C68.3725 90.9525 68.3725 89.0825 67.2225 87.9425ZM5.02253 50.6225C3.87253 49.4725 2.0125 49.4725 0.8625 50.6225C-0.2875 51.7725 -0.2875 53.6325 0.8625 54.7825C2.0125 55.9325 3.87253 55.9325 5.02253 54.7825C6.17253 53.6325 6.17253 51.7725 5.02253 50.6225ZM17.4625 63.0625C16.3125 61.9125 14.4525 61.9125 13.3025 63.0625C12.1525 64.2125 12.1525 66.0725 13.3025 67.2225C14.4525 68.3725 16.3125 68.3725 17.4625 67.2225C18.6125 66.0725 18.6125 64.2125 17.4625 63.0625ZM29.9025 75.5025C28.7525 74.3525 26.8925 74.3525 25.7425 75.5025C24.5925 76.6525 24.5925 78.5125 25.7425 79.6625C26.8925 80.8125 28.7525 80.8125 29.9025 79.6625C31.0525 78.5125 31.0525 76.6425 29.9025 75.5025ZM42.3425 87.9425C41.1925 86.7925 39.3325 86.7925 38.1825 87.9425C37.0325 89.0925 37.0325 90.9525 38.1825 92.1025C39.3325 93.2525 41.1925 93.2525 42.3425 92.1025C43.4925 90.9525 43.4925 89.0825 42.3425 87.9425ZM54.7825 100.372C53.6325 99.2225 51.7725 99.2225 50.6225 100.372C49.4725 101.522 49.4725 103.382 50.6225 104.532C51.7725 105.682 53.6325 105.682 54.7825 104.532C55.9325 103.392 55.9325 101.522 54.7825 100.372Z"
                                        fill="#E9417D"
                                    ></path>
                                </svg>
                            </div>

                            <form v-on:submit.prevent="activatePromocode">
                                <div class="form__main form-activate-promocode">
                                    <div class="form__wrap">
                                        <label class="form__label">
                                            <span 
                                                :class="{'_form-error': errors.promocode}"
                                                class="form__input-wrap _before">
                                                <input
                                                    v-model="promocode"
                                                    @input="errors.promocode = false, promocodeUpperCase()"
                                                    @change="getPromocode"
                                                    autocomplete="off"
                                                    type="text"
                                                    placeholder="BONUS100"
                                                    class="input"/>
                                            </span>

                                            <span class="error-input" v-if="errors.promocode">{{ errors.promocode }}</span>

                                            <div class="preloader-promocode-activate" v-if="loader_promocode">
                                                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                                            </div>

                                            <template v-if="utils.promocode && utils.promocode.wager > 0 && utils.promocode.action == 1">
                                                <tippy
                                                    :onHide="typpyHide"
                                                    :arrow="true"
                                                    :visible="true" 
                                                    placement="top-end"
                                                    theme="rejected_doc"
                                                    arrowType="round"
                                                    to="visiblePromoInfo"
                                                    :trigger="tippy.trigger"> 
                                                    <h3>{{ $store.state.translation.promo.main.alert }}</h3> 
                                                    <span>{{ $sprintf($store.state.translation.promo.main.min_deposit, utils.promocode.min_deposit, $store.state.user.data.merchant.currency) }}</span>
                                                </tippy>

                                                <div 
                                                    name="visiblePromoInfo"
                                                    class="info-promocode">
                                                    <img src="../../assets/img/info.svg">
                                                </div>
                                            </template>

                                            <template v-else-if="utils.promocode && utils.promocode.wager > 0 && utils.promocode.action == 2">
                                                <tippy
                                                    :onHide="typpyHide"
                                                    :arrow="true"
                                                    :visible="true" 
                                                    placement="top-end"
                                                    theme="rejected_doc"
                                                    arrowType="round"
                                                    to="visiblePromoInfo"
                                                    :trigger="tippy.trigger"> 
                                                    <h3>{{ $store.state.translation.promo.main.alert }}</h3> 
                                                    <span>{{ $sprintf($store.state.translation.promo.main.to_wager, utils.promocode.wager) }}</span>
                                                </tippy>

                                                <div 
                                                    name="visiblePromoInfo"
                                                    class="info-promocode">
                                                    <img src="../../assets/img/info.svg">
                                                </div>
                                            </template>
                                        </label>
                                    </div>
                                </div>

                                <div class="popup__buttons">
                                    <button type="submit" class="promocode-btn" :class="{'disabled-button': loader_button || !utils.promocode}">
                                        <loading-button v-if="loader_button"/>
                                        <span>{{ $store.state.translation.promo.main.active_btn }}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <main class="page">
            <section class="content">
                <div class="content__container">
                    <h1 class="graph-title graph-title--mb">
                        <span>
                            <svg class="_animation-object _animation-object-dashes" width="168" height="43" viewBox="0 0 168 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M153.094 17.6816L138.864 3.52086L124.625 17.6816L110.395 3.52086L96.1652 17.6816L83.6144 5.19142L71.0549 17.6816L56.8249 3.52086L42.5862 17.6816L28.3562 3.52086L14.1262 17.6816L0 3.62473L1.57534 2.04939L14.1262 14.5396L28.3562 0.378829L42.5862 14.5396L56.8249 0.378829L71.0549 14.5396L83.6144 2.04073L96.1652 14.5396L110.395 0.378829L124.625 14.5396L138.864 0.378829L153.094 14.5396L165.653 2.04939L167.22 3.62473L153.094 17.6816Z"
                                    fill="#E9417D"
                                ></path>
                                <path
                                    d="M153.094 43L138.864 28.8392L124.625 43L110.395 28.8392L96.1652 43L84.8781 31.7649L84.8694 28.6142L96.1652 39.858L110.395 25.6972L124.625 39.858L138.864 25.6972L153.094 39.858L165.653 27.3677L167.22 28.9517L153.094 43Z"
                                    fill="#E9417D"
                                ></path>
                            </svg>
                            <span>{{ $store.state.translation.promo.title }}</span>
                            <svg class="_animation-object _animation-object-cross" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.4 11.36L8.95 6.90999L13.4 2.45999C13.96 1.89999 13.96 0.98 13.4 0.42C12.84 -0.14 11.92 -0.14 11.36 0.42L6.90999 4.87L2.45999 0.42C1.89999 -0.14 0.98 -0.14 0.42 0.42C-0.14 0.98 -0.14 1.89999 0.42 2.45999L4.87 6.90999L0.42 11.36C-0.14 11.92 -0.14 12.84 0.42 13.4C0.98 13.96 1.89999 13.96 2.45999 13.4L6.90999 8.95L11.36 13.4C11.92 13.96 12.84 13.96 13.4 13.4C13.97 12.84 13.97 11.93 13.4 11.36Z"
                                    fill="#FFC263"
                                ></path>
                            </svg>
                            <svg class="_animation-object _animation-object-cross" width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.18414 19.9265L19.9348 5.17578C17.3161 6.67223 14.8843 8.46262 12.6842 10.4935L10.5019 12.6758C8.47098 14.876 6.68059 17.3077 5.18414 19.9265Z" fill="#E9417D"></path>
                                <path d="M0.783875 31.6485L31.657 0.775391C30.8019 0.944632 29.9646 1.1495 29.1273 1.37219L1.38066 29.1188C1.15797 29.9561 0.953116 30.7934 0.783875 31.6485Z" fill="#E9417D"></path>
                                <path d="M0 39.4955C0 39.5757 0 39.6648 0 39.7449L39.7538 0C39.6737 0 39.5846 0 39.5044 0C38.9255 0 38.3554 0.0178148 37.7942 0.0356297L0.0445263 37.7853C0.017804 38.3554 0 38.9255 0 39.4955Z" fill="#E9417D"></path>
                                <path d="M0.614646 46.4613L46.4612 0.614761C45.9089 0.516779 45.3478 0.427705 44.7955 0.356445L0.356323 44.7956C0.427583 45.3479 0.516665 45.909 0.614646 46.4613Z" fill="#E9417D"></path>
                                <path d="M2.11105 52.2782L52.2777 2.11162C51.7967 1.94238 51.3068 1.79096 50.8169 1.64844L1.64787 50.8174C1.7993 51.3073 1.95072 51.7972 2.11105 52.2782Z" fill="#E9417D"></path>
                                <path d="M4.29341 57.4176L57.4262 4.28477C56.9986 4.07099 56.5622 3.85721 56.1257 3.65234L3.66096 56.1171C3.86584 56.5536 4.07073 56.99 4.29341 57.4176Z" fill="#E9417D"></path>
                                <path d="M7.0369 61.9956L62.0046 7.02788C61.6216 6.76065 61.2386 6.50234 60.8467 6.25293L6.26196 60.8376C6.51137 61.2296 6.76968 61.6126 7.0369 61.9956Z" fill="#E9417D"></path>
                                <path d="M10.2792 66.0757L66.0753 10.2795C65.7368 9.97668 65.3984 9.67383 65.051 9.37988L9.37956 65.0513C9.67351 65.3898 9.97637 65.7372 10.2792 66.0757Z" fill="#E9417D"></path>
                                <path d="M14.0114 69.6645L69.6739 14.002C69.38 13.6546 69.0771 13.3072 68.7743 12.9688L12.9781 68.7649C13.3166 69.0677 13.6551 69.3706 14.0114 69.6645Z" fill="#E9417D"></path>
                                <path d="M18.2157 72.7737L72.7826 18.2068C72.5332 17.8149 72.2749 17.4318 72.0077 17.0488L17.0578 72.0077C17.4408 72.266 17.8238 72.5243 18.2157 72.7737Z" fill="#E9417D"></path>
                                <path d="M22.9456 75.3662L75.3658 22.946C75.1609 22.5095 74.956 22.0731 74.7333 21.6455L21.6362 74.7427C22.0726 74.9565 22.5091 75.1613 22.9456 75.3662Z" fill="#E9417D"></path>
                                <path d="M28.2632 77.3703L77.3788 28.2548C77.2363 27.7649 77.076 27.2749 76.9156 26.7939L26.8024 76.9071C27.2834 77.0764 27.7733 77.2278 28.2632 77.3703Z" fill="#E9417D"></path>
                                <path d="M34.3025 78.6527L78.6615 34.2937C78.5902 33.7326 78.5012 33.1714 78.4032 32.6191L32.6279 78.3944C33.1802 78.4924 33.7413 78.5815 34.3025 78.6527Z" fill="#E9417D"></path>
                                <path
                                    d="M39.5045 78.9995C40.1191 78.9995 40.7248 78.9817 41.3216 78.955L78.9554 41.3211C78.9822 40.7154 79 40.1097 79 39.504C79 39.4505 79 39.406 79 39.3525L39.353 78.9995C39.3976 78.9906 39.451 78.9995 39.5045 78.9995Z"
                                    fill="#E9417D"
                                ></path>
                                <path d="M50.0152 77.5749L77.5837 50.0064C77.8153 49.1691 78.0202 48.3229 78.1983 47.4678L47.4766 78.1895C48.3317 78.0113 49.1779 77.8065 50.0152 77.5749Z" fill="#E9417D"></path>
                                <path d="M73.6733 59.3057L59.3056 73.6733C65.2558 70.2173 70.2172 65.2558 73.6733 59.3057Z" fill="#E9417D"></path>
                            </svg>
                            <svg class="_animation-object _animation-object-rhombus" width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.76 10.76L0 0V21.52L10.76 10.76Z" fill="#DA5077"></path>
                                <path d="M27.1 10.76L16.33 0V21.52L27.1 10.76Z" fill="#DA5077"></path>
                            </svg>
                        </span>
                    </h1>

                    <div class="promo-code" v-if="'auth' in $store.state.user && $store.state.user.auth">
                        <button @click="openPopup('enter-promo')" class="form__btn form-btn">
                            <span>{{ $store.state.translation.promo.main.activate_promocode }}</span>
                        </button>
                    </div>

                    <div class="content__promo-items promo-items">
                        <div class="promo-items__item promo-items-item _before">
                            <picture>
                                <img :src="require(`../../assets/img/promo/start_${$store.state.lang}.png`)" width="427" height="427" alt="" />
                            </picture>
                            <div class="promo-link">
                                <router-link :to="{name: 'PromoStarting'}">
                                    {{ $store.state.translation.promo.main.details }}
                                </router-link>
                            </div>
                        </div>
                        <div class="promo-items__item promo-items-item _before" v-if="'auth' in $store.state.user">
                            <picture>
                                <img :src="require(`../../assets/img/promo/personal_${$store.state.lang}.png`)" width="427" height="427" alt="" />
                            </picture>
                            <div class="promo-link">
                                <router-link :to="{name: 'PromoPersonal'}" v-if="'auth' in $store.state.user && $store.state.user.auth">
                                    {{ $store.state.translation.promo.main.details }}
                                </router-link>
                                <a @click="openPopup('sign-in')" v-else>
                                    {{ $store.state.translation.promo.main.details }}
                                </a>
                            </div>
                        </div>
                        <div class="promo-items__item promo-items-item _before">
                            <picture>
                                <img :src="require(`../../assets/img/promo/status_${$store.state.lang}.png`)" width="427" height="427" alt="" />
                            </picture>
                            <div class="promo-link">
                                <router-link :to="{name: 'PromoStatus'}">
                                    {{ $store.state.translation.promo.main.details }}
                                </router-link>
                            </div>
                        </div>
                        <div class="promo-items__item promo-items-item _before">
                            <picture>
                                <img :src="require(`../../assets/img/promo/cashback_${$store.state.lang}.png`)" width="427" height="427" alt="" />
                            </picture>
                            <div class="promo-link">
                                <router-link :to="{name: 'PromoCashback'}">
                                    {{ $store.state.translation.promo.main.details }}
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="promo-history" v-if="'auth' in $store.state.user && $store.state.user.auth">
                        <router-link class="form__btn form-btn" :to="{name: 'CashierPromotionsHistory'}">
                            <span>{{ $store.state.translation.promo.main.bonus_history }}</span>
                        </router-link>
                    </div>
                </div>
            </section>

            <section class="content">
                <div class="content__container">
                    <h2 class="content__title title title--center">{{ $store.state.translation.promo.main.bonus_casino }}</h2>
                    <div class="content__column">
                        <div class="content__col">
                            <h3 class="content__title mini-title">{{ $store.state.translation.promo.main.contains }}</h3>
                            <nav class="content__navigation">
                                <ul class="content__list" data-anchor-links="">
                                    <li><span>{{ $store.state.translation.promo.main.types }}</span></li>
                                    <li><button type="button" data-goto="#welcome" data-goto-header="">{{ $store.state.translation.promo.main.welcome }}</button></li>
                                    <li><button type="button" data-goto="#personal" data-goto-header="">{{ $store.state.translation.promo.main.personal }}</button></li>
                                    <li><button type="button" data-goto="#cashback" data-goto-header="">{{ $store.state.translation.promo.main.cashback }}</button></li>
                                    <li><button type="button" data-goto="#no-deposit" data-goto-header="">{{ $store.state.translation.promo.main.no_deposit }}</button></li>
                                    <li><button type="button" data-goto="#stats" data-goto-header="">{{ $store.state.translation.promo.main.statuses }}</button></li>
                                    <li><button type="button" data-goto="#how-to-get" data-goto-header="">{{ $store.state.translation.promo.main.how_to_get }}</button></li>
                                    <li><button type="button" data-goto="#how-to-open" data-goto-header="">{{ $store.state.translation.promo.main.how_to_open }}</button></li>
                                    <li><button type="button" data-goto="#rules" data-goto-header="">{{ $store.state.translation.promo.main.rules }}</button></li>
                                    <li><button type="button" data-goto="#questions" data-goto-header="">{{ $store.state.translation.promo.main.questions }}</button></li>
                                </ul>
                            </nav>
                        </div>
                        <div class="content__col">
                            <p class="_paragraph-mb">
                                {{ $store.state.translation.promo.main.text1 }}
                            </p>
                            <h2 class="content__title title mini-title">{{ $store.state.translation.promo.main.text2 }}</h2>
                            <p>
                                {{ $store.state.translation.promo.main.text3 }}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <div data-showmore="" class="show-more">
                <div data-showmore-content="0" class="show-more__content" style="height: 0px; overflow: hidden;">
                    <section id="welcome" class="content">
                        <div class="content__container">
                            <h2 class="content__title title mini-title">{{ $store.state.translation.promo.main.text4 }}</h2>
                            <p>
                                {{ $store.state.translation.promo.main.text5 }}
                            </p>
                            <ul class="list">
                                <li>
                                    {{ $store.state.translation.promo.main.text6 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text7 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text8 }}
                                </li>
                            </ul>
                        </div>
                    </section>
                    <section id="personal" class="content">
                        <div class="content__container">
                            <h2 class="content__title title mini-title">{{ $store.state.translation.promo.main.text9 }}</h2>
                            <p>
                                {{ $store.state.translation.promo.main.text10 }}
                            </p>
                        </div>
                    </section>
                    <section id="cashback" class="content">
                        <div class="content__container">
                            <h2 class="content__title title mini-title">{{ $store.state.translation.promo.main.text11 }}</h2>
                            <p>
                                {{ $store.state.translation.promo.main.text12 }}
                            </p>
                            <table class="content__table table--half">
                                <caption>
                                    {{ $store.state.translation.promo.main.text13 }}
                                </caption>
                                <thead>
                                    <tr>
                                        <th>{{ $store.state.translation.promo.main.text14 }}</th>
                                        <th>{{ $store.state.translation.promo.main.text15 }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in $store.state.promo_statuses">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.cashback }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>
                                {{ $store.state.translation.promo.main.text16 }}
                            </p>
                        </div>
                    </section>
                    <section id="no-deposit" class="content">
                        <div class="content__container">
                            <h2 class="content__title title mini-title">{{ $store.state.translation.promo.main.text17 }}</h2>
                            <p>
                                {{ $store.state.translation.promo.main.text18 }}
                            </p>
                        </div>
                    </section>
                    <section id="stats" class="content">
                        <div class="content__container">
                            <h2 class="content__title title mini-title">{{ $store.state.translation.promo.main.text19 }}</h2>
                            <p>
                                {{ $store.state.translation.promo.main.text20 }}
                            </p>
                            <table class="content__table table--half">
                                <caption>
                                    {{ $store.state.translation.promo.main.text21 }}
                                </caption>
                                <thead>
                                    <tr>
                                        <th>{{ $store.state.translation.promo.main.text22 }}</th>
                                        <th>{{ $sprintf($store.state.translation.promo.main.text23, $store.state.user.data.merchant.currency) }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in $store.state.promo_statuses">
                                        <td>{{ item.name }}</td>
                                        <td>
                                            <template v-if="index == 0">
                                                {{ $sprintf($store.state.translation.promo.main.from, '0', $store.state.user.data.merchant.currency_sign) }}
                                            </template>
                                            <template v-else>
                                                {{ $sprintf($store.state.translation.promo.main.from, (parseFloat($store.state.promo_statuses[index].deposits) + 1), $store.state.user.data.merchant.currency_sign) }}
                                            </template>

                                            
                                            <template v-if="index + 1 < $store.state.promo_statuses.length">
                                                {{ $sprintf($store.state.translation.promo.main.to, ($store.state.promo_statuses[index + 1].deposits), $store.state.user.data.merchant.currency_sign) }}
                                            </template>
                                            <template v-if="index + 1 >= $store.state.promo_statuses.length">
                                                {{ $store.state.translation.promo.main.and_more }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>
                                {{ $store.state.translation.promo.main.text24 }}
                            </p>
                        </div>
                    </section>
                    <section id="how-to-get" class="content">
                        <div class="content__container">
                            <h2 class="content__title title mini-title">{{ $store.state.translation.promo.main.text25 }}</h2>
                            <p>
                                {{ $store.state.translation.promo.main.text26 }}
                            </p>
                        </div>
                    </section>
                    <section id="how-to-open" class="content">
                        <div class="content__container">
                            <h2 class="content__title title mini-title">{{ $store.state.translation.promo.main.text27 }}</h2>
                            <p>
                                {{ $store.state.translation.promo.main.text28 }}
                            </p>
                            <ul class="list">
                                <li>
                                    {{ $store.state.translation.promo.main.text29 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text30 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text31 }}
                                </li>
                            </ul>
                            <p>
                                {{ $store.state.translation.promo.main.text32 }}
                            </p>
                        </div>
                    </section>
                    <section id="rules" class="content">
                        <div class="content__container">
                            <h2 class="content__title title mini-title">{{ $store.state.translation.promo.main.text33 }}</h2>
                            <p>
                                {{ $store.state.translation.promo.main.text34 }}
                            </p>
                            <ul class="list">
                                <li>
                                    {{ $store.state.translation.promo.main.text35 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text36 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text37 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text38 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text39 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text40 }}
                                </li>
                                <li>
                                    {{ $store.state.translation.promo.main.text41 }}
                                </li>
                            </ul>
                            <p>
                                {{ $store.state.translation.promo.main.text42 }}
                            </p>
                        </div>
                    </section>
                    <section id="questions" class="content">
                        <div class="content__container">
                            <h2 class="content__title title">{{ $store.state.translation.promo.main.text43 }}</h2>
                            <div class="content__blocks">
                                <div class="content__block">
                                    <h3 class="content__middle-title content__middle-title--min">{{ $store.state.translation.promo.main.text44 }}</h3>
                                    <p class="content__paragraph">
                                        {{ $store.state.translation.promo.main.text45 }}
                                    </p>
                                    <h3 class="content__middle-title content__middle-title--min">{{ $store.state.translation.promo.main.text46 }}</h3>
                                    <p class="content__paragraph">
                                        {{ $store.state.translation.promo.main.text47 }}
                                    </p>
                                </div>
                                <div class="content__block">
                                    <h3 class="content__middle-title content__middle-title--min">{{ $store.state.translation.promo.main.text48 }}</h3>
                                    <p class="content__paragraph">
                                        {{ $store.state.translation.promo.main.text49 }}
                                    </p>
                                    <h3 class="content__middle-title content__middle-title--min">{{ $store.state.translation.promo.main.text50 }}</h3>
                                    <p class="content__paragraph">
                                        {{ $store.state.translation.promo.main.text51 }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>

        <footer-main></footer-main>
    </div>
</template>

<script>
    export default {
        metaInfo () {
            return {
                title: this.$store.state.translation.promo.main.meta.title,
                meta: [
                    {
                        name: 'title', 
                        content: this.$store.state.translation.promo.main.meta.title
                    },
                    {
                        name: 'keywords', 
                        content: this.$store.state.translation.promo.main.meta.keywords
                    },
                    {
                        name: 'description', 
                        content: this.$store.state.translation.promo.main.meta.description
                    }
                ]
            }
        },
        data() {
            return {
                promocode: null,
                loader_button:  false,
                loader_promocode: false,
                errors: {
                    promocode: false
                },
                utils: {
                    promocode: null
                },
                tippy: {
                    trigger: 'manual'
                }
            }
        },
        methods: {
            getPromocode () {
                if(this.promocode) {
                    this.utils.promocode = null
                    this.loader_promocode = true
                    this.$axios.post('/promocodes/item', JSON.stringify({
                        promocode: this.promocode,
                        action: null
                    }))
                    .then((response) => {
                        this.loader_promocode = false
                        response = response.data
                        switch (response.status) {
                            case 'error':
                                this.$toast.error(response.message)
                                break
                            case 'success':

                                this.utils.promocode = response.data

                                this.setUser(response.user)
                                
                                break
                            default:
                                this.$toast.error(this.$store.state.translation.default.unknown_error)
                        }
                    }).catch((error) => {
                        this.loader_promocode = false
                        let response = error.response.data
                        this.setUser(response.user)

                        if(response && 'status' in response && response.status == 'error') {
                            this.$toast.error(response.message)
                            if('field' in response) {
                                this.errors[response.field] = response.message
                            }
                        }
                    })
                }
            },
            activatePromocode () {

                if(this.utils.promocode.action == 1) {
                    this.$store.state.promocode = this.promocode
                    this.closePopup(document.getElementById('enter-promo'))
                    return this.$router.push({name: 'CashierDeposit'})
                }

                //if(this.promocode) {
                    this.loader_button = true

                    this.$axios.post('/promocodes/activate', JSON.stringify({
                        promocode: this.promocode
                    }))
                    .then((response) => {
                        this.loader_button = false
                        response = response.data
                        switch (response.status) {
                            case 'error':
                                this.$toast.error(response.message)
                                break
                            case 'success':

                                this.$toast.success(response.message)

                                this.closePopup(document.getElementById('enter-promo'))

                                this.$router.push({name: 'CashierPromotionsHistory'})

                                this.setUser(response.user)
                                
                                break
                            default:
                                this.$toast.error(this.$store.state.translation.default.unknown_error)
                        }
                    }).catch((error) => {
                        this.loader_button = false
                        let response = error.response.data
                        this.setUser(response.user)

                        if(response && 'status' in response && response.status == 'error') {
                            this.$toast.error(response.message)
                        }
                    })
                //}
            },
            typpyHide (e) {
                this.tippy.trigger = 'mouseenter focus'
            },
            promocodeUpperCase () {
                this.promocode = this.promocode.toUpperCase()
            }
        },
        beforeMount() {
            if(!this.$store.state.promo_statuses.length) {
                this.getPromoStatuses()
            }
        },
        mounted() {
            document.querySelectorAll('button[data-goto]').forEach(item => {
                item.addEventListener('click', event => {
                    document.querySelector('.show-more').classList.add('_showmore-active')
                    document.querySelector('.show-more__content').removeAttribute('style')

                    let element = document.querySelector(event.target.getAttribute('data-goto'))
                    element.scrollIntoView()
                })
            })
        }
    }
</script>
